<div class="row mt-3 mb-3">
  <div class="col-3">
    <button (click)="adicionarDocumento()" #btnAdicionarDocumento class="btn btn-sm btn-success">
      <img src="assets/img/global/plus.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Adicionar Documento
    </button>
  </div>
</div>
<table class="table table-eddy" *ngIf="listaDocumentos && listaDocumentos.length > 0">
  <thead>
    <tr>
      <th scope="col">Data Doc.</th>
      <th scope="col">Documento</th>
      <th scope="col">CNPJ</th>
      <th scope="col">Razão social</th>
      <th scope="col">Valor</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of listaDocumentos; let idx = index">
      <td *ngIf="!item.editavel" style="width: 200px">{{item.data_documento | date:'dd/MM/yyyy':'GMT'}}</td>
      <td *ngIf="!item.editavel" style="width: 150px">{{item.documento}}</td>
      <td *ngIf="!item.editavel" style="width: 250px">{{item.cnpj}}</td>
      <td *ngIf="!item.editavel" style="width: 30%">{{item.razao_social}}</td>
      <td *ngIf="!item.editavel" style="width: 200px">{{item.valor_documento | number:'1.2-2'}}</td>

      <td *ngIf="item.editavel" style="width: 280px">
        <p-calendar id="data_doc" [(ngModel)]="entity.data_documento" inputStyleClass="form-control form-control-sm"
          dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
          [showButtonBar]="true" [style]="{ width: '100%' }">
        </p-calendar>
      </td>
      <td *ngIf="item.editavel" style="width: 200px">
        <input [(ngModel)]="entity.documento" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" id="documento">
      </td>
      <td *ngIf="item.editavel" style="width: 300px">
        <input [(ngModel)]="entity.cnpj" unmask="true" [imask]="{mask: '000.000.000/0000-00'}"
          [ngModelOptions]="{standalone: true}" type="text" class="form-control form-control-sm" id="cnpj">
      </td>
      <td *ngIf="item.editavel" style="width: 30%">
        <input [(ngModel)]="entity.razao_social" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" id="razao_social">
      </td>
      <td *ngIf="item.editavel" style="width: 350px">
        <input [(ngModel)]="entity.valor_documento" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" unmask="true" [imask]="imaskConfig" id="valor_documento"
          placeholder="0,00">
      </td>
      <td class="text-right" style="min-width: 150px;">
        <button *ngIf="item.editavel" (click)="salvarDocumento(item)" class="btn btn-sm btn-outline-secondary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="cancelarDocumento(item, idx)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" #btnsEditar (click)="editarDocumento(item)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="confirmarRemocao(item, idx)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>
<div class="row">
  <div class="col-9 font-weight-bold">
    <span *ngIf="listaDocumentos && listaDocumentos.length > 0">TOTAL: {{total | number:'1.2-2'}}</span>
  </div>
</div>